@if (vm$ | async; as vm) {
  <div class="validation-results">
    @if (vm.showAlert) {
      @if (vm.inProgress) {
        <animated-border-wrapper class="validation-results__alert">
          <jui-alert-block
            size="sm"
            [color]="vm.blockColor"
            [iconName]="vm.iconName"
            [titleText]="vm.title">
            {{vm.message}}
          </jui-alert-block>
        </animated-border-wrapper>
      } @else {
        <jui-alert-block
          class="validation-results__alert"
          size="sm"
          [color]="vm.blockColor"
          [iconName]="vm.iconName"
          [titleText]="vm.title">
          {{vm.message}}
        </jui-alert-block>
      }
    }

    @if (vm.showReassuranceMessage) {
      <div class="validation-results__reassurance">
        {{vm.reassuranceMessage}}
      </div>
    }
  </div>
}
